import "./Contact.css";
import { useState } from "react";

export default function Contact() {

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("DATA:", { name, phone, email, purity, gram });

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
   const res = await fetch("https://goldcompanynearme.com/send.php", {
  method: "POST",
  body: formData,
  mode: "cors",          // ✅ ADD THIS
});
     

      // ✅ FIX: read as text first
      const text = await res.text();
      console.log("RAW RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        alert("Server response error ❌");
        return;
      }

      console.log("PARSED:", data);

      if (data.status === "success") {
        alert("Submitted Successfully ✅");

        setName("");
        setPhone("");
        setEmail("");
        setPurity("");
        setGram("");
      } else {
        alert(data.msg || "Server Error ❌");
      }

    } catch (err) {
      console.error("FETCH ERROR:", err);
      alert("Server Error ❌");
    }
  };

  return (
    <section id="contact" className="contact-new">
      <div className="contact-box">

        {/* LEFT */}
        <div className="contact-left">
          <h2>Sell Your Gold at Best Price</h2>
          <p>
            Get instant cash with trusted gold buyers.
            Transparent process and best market value guaranteed.
          </p>

          <ul>
            <li>✔ Instant Payment</li>
            <li>✔ Free Gold Testing</li>
            <li>✔ Trusted Service</li>
          </ul>
        </div>

        {/* RIGHT FORM */}
        <div className="contact-right">
          <form onSubmit={handleSubmit}>

            {/* NAME */}
            <div className="input-group">
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label>Name</label>
            </div>

            {/* PHONE */}
            <div className="input-group">
              <input
                type="text"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <label>Phone Number</label>
            </div>

            {/* EMAIL */}
            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>Email</label>
            </div>

            {/* PURITY */}
            <div className="input-group">
              <select
                required
                value={purity}
                onChange={(e) => setPurity(e.target.value)}
              >
                <option value="" disabled hidden></option>
                <option value="18K">18K</option>
                <option value="20K">20K</option>
                <option value="22K">22K</option>
                <option value="24K">24K</option>
              </select>
              <label>Gold Purity</label>
            </div>

            {/* GRAM */}
            <div className="input-group">
              <input
                type="text"
                value={gram}
                onChange={(e) => setGram(e.target.value)}
              />
              <label>Weight (grams)</label>
            </div>

            <button type="submit">Get Best Price</button>

          </form>
        </div>

      </div>
    </section>
  );
}